import {useContext} from "react";
import {BulkCrosswordContext} from "./BulkCrossword.context";

export const useBulkCrosswordContext = () => {
	return useContext(BulkCrosswordContext);
};